export function AlphabeticalAsc() {
  return <span>A → Z</span>;
}
